export enum AccessModesEnum {
  NOACESS = 0,
  ACCESS = 1,
  LATER = 2,
}
